import React from 'react';
import ThirdPartyAccountUpdateCard from '../components/ThirdPartyAccountUpdateCard';

export default function ThirdPartyAccountUpdateCardScreen() {
  return <ThirdPartyAccountUpdateCard />;
}
